import { render, staticRenderFns } from "./QuizFasterAnswerGetMorePointToggle.vue?vue&type=template&id=d3be5256&"
import script from "./QuizFasterAnswerGetMorePointToggle.vue?vue&type=script&lang=js&"
export * from "./QuizFasterAnswerGetMorePointToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports